import { Box } from '@mantine/core';
import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/administration/_administration/university-config/_university-config')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'sidebar.universityConfig' },
  },
});

function RouteComponent() {
  return (
    <Box p="md">
      <Outlet />
    </Box>
  );
}
